// AIMA official social media URLs.
// Leave a value as an empty string ("") to render the icon as a disabled
// visual placeholder (subtle reduced opacity, no href, not clickable).
// As soon as a real URL is added below, the icon becomes a clickable
// external link automatically — no other code changes required.

export const socialLinks = {
    // Add official AIMA X (Twitter) URL here, e.g. "https://x.com/AIMAmarket"
    x: "https://x.com/AIMAmarket",
    // Add official AIMA GitHub URL here, e.g. "https://github.com/sales908/aima-token-v2"
    github: "https://github.com/sales908/aima-token-v2",
    // Add official AIMA Discord invite URL here, e.g. "https://discord.gg/pdXHGZPXWQ"
    discord: "https://discord.gg/pdXHGZPXWQ",
    // Add official AIMA Telegram URL here, e.g. "https://t.me/AIMAmarket"
    telegram: "https://t.me/AIMAmarket",
    // Add official AIMA TikTok URL here, e.g. "https://www.tiktok.com/@aima"
    tiktok: "https://www.tiktok.com/@aimamarket",
    // Add official AIMA Farcaster URL here, e.g. "https://warpcast.com/aima"
    whatsapp: "https://whatsapp.com/channel/0029VbDBT7d1SWtA1Jex5m1U",
};

export default socialLinks;
